import React from 'react';
import { Route, Switch } from 'react-router-dom';
import routes from './routes'
import { connect } from 'react-redux';
import PrivateRoute from './routes/privateRoutes'
import ErrorBoundary from './components/shared/ErrorBoundary'
import "react-loadingmask/dist/react-loadingmask.css";

class App extends React.Component {
  render() {
    return (
      <Switch>
        {
          routes.map(({ path, exact, component: C, authentication, ...rest }) => {
            if (!authentication) {
              // Public screens (login, forgot/reset password) get their own
              // boundary — they render outside the dashboard shell, so nothing
              // else would catch a throw here. Keyed by path so moving between
              // them clears a previous error.
              return (<Route
                key={path}
                path={path}
                exact={exact}
                render={(props) => (
                  <ErrorBoundary key={props.location.pathname}>
                    <C {...props} {...rest} />
                  </ErrorBoundary>
                )}
              />)
            } else {
              return <PrivateRoute
                key={path}
                path={path}
                exact={exact}
                component={C}
                authentication={authentication}
              />
            }

          })
        }
      </Switch>
    );
  }
}

const mapStateToProps = store => {
  return {
    admin: store.user
  }
}

export default connect(mapStateToProps, {

})(App);
